module.exports = __webpack_public_path__ + "static/media/grand_mum_friend_talking.6cc5e67e.png";